import React, { useState } from 'react';

import { BulkPlaybookUpdateTableWrapper } from '@ion/ion-experimental';

import ModalContextProvider from 'app/pipelines/ModalContext';
import EditPipelineNameModal from 'app/pipelines/modals/EditPipelineNameModal';
import ConfirmDeleteModal from 'app/pipelines/modals/ConfirmDeleteModal';
import PipelinesAuditLogModal from 'app/pipelines/modals/PipelinesAuditLogModal';
import PipelinesTable from './PipelinesTable';
import { PipelinesTableContextProvider } from 'app/pipelines/PipelinesTable/PipelinesTableContext';

const VIEWS = {
  PIPELINES: 'pipelines',
  BULK_PLAYBOOK_UPDATE: 'bulkPlaybookUpdate',
};

export default function PipelinesPageContent() {
  const [activeView, setActiveView] = useState(VIEWS.PIPELINES);

  const handleShowBulkPlaybookUpdate = () => {
    setActiveView(VIEWS.BULK_PLAYBOOK_UPDATE);
  };

  const handleExitBulkPlaybookUpdate = () => {
    setActiveView(VIEWS.PIPELINES);
  };

  if (activeView === VIEWS.BULK_PLAYBOOK_UPDATE) {
    return <BulkPlaybookUpdateTableWrapper onExit={handleExitBulkPlaybookUpdate} />;
  }

  return (
    <PipelinesTableContextProvider>
      <ModalContextProvider>
        <PipelinesTable onShowBulkPlaybookUpdate={handleShowBulkPlaybookUpdate} />

        <EditPipelineNameModal />
        <ConfirmDeleteModal />
        <PipelinesAuditLogModal />
      </ModalContextProvider>
    </PipelinesTableContextProvider>
  );
}
